<template>
  <div class="face-recog">
    <div class="face-recog-container" v-if="cameraRecog">
      <div class="info-desc">
        <p class="title">请<strong class="ta--text-warning">本人</strong>进行验证，<strong class="ta--text-warning">拍照时注意所处环境及个人形象</strong>，并确认：</p>
        <div class="info">
          <div class="explain">
            <p>1. 照片光照均匀，不过度曝光或背光；</p>
            <p>2. 照片中人脸正面、完整位于画面框中；</p>
            <p>3. 照片中人脸轮廓清晰，眼、鼻、嘴等重要部位不被遮挡且可辨认；</p>
          </div>

          <div class="avatar">
            <img :src="`/m/home/my/a/idphoto.png`" @error="avatarFailed" v-if="showAvatar">
            <img src="../assets/avatar.png" v-if="!showAvatar">
          </div>
        </div>
      </div>
      <article class="video-container">
        <div class="frame-container">
          <div class="frame">
            <div class="frame-item left top"></div>
            <div class="frame-item right top"></div>
            <div class="frame-item left bottom"></div>
            <div class="frame-item right bottom"></div>
          </div>
        </div>
        <section>
          <video v-show="!isReady" id="video" width="640" height="480"></video>
        </section>
        <section>
          <!--        <audio id="audio"></audio>-->
        </section>
        <section style="display: none;">
          <canvas id="canvas" width="640" height="480"></canvas>
        </section>
        <section v-show="isReady"><img src="" alt="" id="img"></section>
      </article>
      <div class="action-container">
        <div class="button primary ta--bg-primary" v-if="!isReady" style="cursor: pointer" @click="tackcapture">
          <i class="icon mdi mdi-camera"></i>
          <span>开始拍照</span>
        </div>
        <div class="button" v-if="isReady" style="cursor: pointer" @click="isReady = false">
          <i class="icon mdi mdi-refresh"></i>
          <span>重新拍照</span>
        </div>
        <div class="button primary ta--bg-primary" v-if="isReady" style="cursor: pointer" @click="submit">
          <i class="icon mdi mdi-upload"></i>
          <span>提交验证</span>
        </div>
      </div>
<!--      <button @click="tackcapture" v-if="!isReady">拍照验证</button>-->
<!--      <button @click="isReady = false" v-if="isReady">重新拍摄</button>-->
<!--      <button @click="submit" v-if="isReady">提交</button>-->
    </div>
    <div class="wechat-qr-recog" v-else>
      <h2>请使用微信扫码验证拍照</h2>
      <div class="wechat-qr-container">
        <img class="wechat-qr" :src="`/m/home/my/facerecog/take/${$store.state.clazzId}/qrcode.png?_=${ts}`" alt="">
        <div class="qr-code-modal" v-if="qrCountDown <= 0" @click="refreshQrCode">
          <div class="tips">二维码已失效</div>
        </div>
      </div>
      <div class="tip-box">
        请在60秒内完成微信端扫码验证
        <span v-if="qrCountDown">
          （{{qrCountDown}}）
        </span>
        <span v-else @click="refreshQrCode">
          （点击刷新）
        </span>
      </div>
    </div>
    <GlobalDialog
        ref="errorDialog"
        :showText="dialogText"
        ignoreCancel="true"
    />
    <GlobalDialog
        ref="idPhotoError"
        ignoreAction="true"
        panelTop="5"
        width="300"
        alertType="normal"
    >
      <template v-slot:content>
        <div class="muti-content">
          <p class="title">人脸验证失败</p>
          <p class="text-left">为保障人脸验证正常通过，请您确认比对照片是否符合以下要求，如不符合，请立即联系所在培训机构更换备案照片</p>
          <p><img src="/m/home/my/a/idphoto.png"></p>
          <div class="panel">
            <p class="p-title">备案照片要求</p>
            <p class="p-item text-left">1. 照片为本人，无美颜，无PS</p>
            <p class="p-item text-left">2. 背景简洁干净，不过度曝光或背光</p>
            <p class="p-item text-left">3. 人脸正面完整，轮廓清晰，五官不被遮挡且可辨认</p>
          </div>
          <div class="active-btn ta--bg-primary" @click="$router.back()">更换后再学习</div>
          <div class="active-link" @click="$refs.idPhotoError.hideDialog()">重新尝试验证>></div>
        </div>
      </template>
    </GlobalDialog>
    <transition name="fade-in">
      <div class="captcha-dialog" v-if="captchaDialog">
        <div class="dialog-bg"></div>
        <div class="dialog-container">
          <div class="content">
            <div class="input-cont"><input type="text" v-model="captcha" @blur="fixBlur" placeholder="请输入图片验证码" ref="phoneCaptcha"></div>
            <!--            <p class="title">请输入图片验证码</p>-->
            <p class="captcha"><img :src="`/m/p/captcha.png?t=${ts}`" @click="ts = Date.now()"></p>
            <p class="desc">看不清？点击图片刷新</p>
          </div>
          <div class="active-buttons">
            <div class="button cancel" @click="captchaCancel">取消</div>
            <div class="button ta--text-primary enter" @click="captchaEnter">确定</div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade-in">
      <div class="face-submit-loading" v-if="isSubmit">
        <div class="loading-dialog">
          正在上传人脸信息，请稍等...
        </div>
      </div>
    </transition>
  </div>

</template>

<script>
	import GlobalDialog from '@/components/GlobalDialog'
  const COUNT_DOWN_START = 60
  export default {
    name: "RecognitionForPC",
		components: {
			GlobalDialog,
		},
    data() {
      return {
        streaming: false,
        isReady: false,
        isSubmit: false,
        showAvatar: true,
				dialogText: '',
				compare_count: 0,

        captchaDialog: false,
        ts: Date.now(),
        captcha: '',
        hasCaptcha: false,

        cameraRecog: true,
        qrCountDown: 0,
        qrCountDownTimer: 0,
        checkQrTimer: 0,
        checkQrCount: 0,
        serverId: ''
      }
    },
    beforeMount() {
      sessionStorage.removeItem('cancelRecogByExam')
      sessionStorage.removeItem('cancelRecogByCourseWare')
      /* 人脸界面刷新，直接返回首页 */
      if(!this.$store.state.facerecog) {
        this.$router.replace('/')
      }
    },
    mounted() {
      this.$store.commit('changeNav', '人脸识别')
      console.log('进入页面')
      if(sessionStorage.getItem('allowDesktopFace')) {
        this.cameraRecog = true
        this.initCamera()
      } else {
        this.cameraRecog = false
        this.initWechatQr()
        this.startCheckQr()
      }
    },
    beforeDestroy() {
      sessionStorage.removeItem('startRecog')
      let laTmp = sessionStorage.getItem('latestAccessTmp')
      clearTimeout(this.qrCountDownTimer)
      clearTimeout(this.checkQrTimer)
      if(laTmp){
        sessionStorage.setItem('latestAccess', laTmp)
      }
      if(this.$store.state.facerecog) {
        /* 未进行人脸识别即退出 */
        // this.$toast('用户放弃人脸识别')
        if(this.$store.state.faceRecognitionType == 2){
          sessionStorage.setItem('cancelRecogByExam', true)
        }
        if(this.$store.state.faceRecognitionType == 1){
          sessionStorage.setItem('cancelRecogByCourseWare', true)
        }
        this.$store.commit('faceRecognitionCancel')
      }
    },
    watch: {
      qrCountDown(val) {
        if(!val) {
          clearInterval(this.qrCountDownTimer)
        }
        if(val == COUNT_DOWN_START) {
          clearInterval(this.qrCountDownTimer)
          this.qrCountDownTimer = setInterval(() => {
            this.qrCountDown --
          }, 1000)
        }
      }
    },
    methods: {
      initWechatQr() {
        this.ts = Date.now()
        this.qrCountDown = COUNT_DOWN_START
        this.checkQrCount = 15
      },
      refreshQrCode() {
        this.initWechatQr()
      },
      startCheckQr() {
        this.checkQrTimer = setInterval(() => {
          if(this.checkQrCount > 0) {
            this.checkQrCount --
            this.$axios.get(`/m/home/my/facerecog/take/${this.$store.state.clazzId}/sync`)
                .then(res => {
                  let data = res.data
                  switch(data.status) {
                    case 'ok':
                      if(data.message) {
                        this.checkQrCount = 0
                        this.serverId = data.message
                        this.submitServerId()
                      }
                      break
                    case 'err':
                      this.$toast(data.message)
                      break
                  }
                })
          }
        }, 5000)
      },
      submitServerId() {
        if(this.isSubmit){
          return
        }
        let clazzId = this.$store.state.clazzId,
            type = this.$store.state.faceRecognitionType,
            logId = sessionStorage.getItem('logId')
        let url = `/m/home/my/facerecog/wx/submit/${clazzId}/${type}/${this.serverId}`
        if(type == 3 && logId) {
          url += `?logId=${logId}`
        }
        this.$axios.post(url)
            .then(resp => {
              this.submitRes(resp.data)
            })
      },
      initCamera() {
        let canvas = document.querySelector("#canvas"); //
        let video = document.querySelector("#video");
        // let audio = document.querySelector("audio");
        let width = 640; //视频和canvas的宽度
        let height = 480; //
        // let streaming = false; // 是否开始捕获媒体

        // 获取用户媒体,包含视频和音频
        navigator.mediaDevices.getUserMedia({
          video: { width: 640, height: 480 , frameRate: 30},
          audio: false
        })
            .then(stream => {
              console.log(stream)
              // video.src = URL.createObjectURL(stream);
              video.srcObject = stream; // 将捕获的视频流传递给video  放弃window.URL.createObjectURL(stream)的使用
              video.play(); //  播放视频
              // audio.srcObject = stream;
              // audio.play();
            })
            .catch(err => {
              console.log(err)
            });

        // 监听视频流就位事件,即视频可以播放了
        let self = this
        video.addEventListener('canplay', function(ev){
          console.log('==视频流就位==')
          if (!self.streaming) {
            height = video.videoHeight / (video.videoWidth/width);

            // video.setAttribute('width', width);
            // video.setAttribute('height', height);
            canvas.setAttribute('width', video.width);
            canvas.setAttribute('height', video.height);
            self.streaming = true;
          }
        }, false);
      },
      fixBlur(e) {
        document.getElementsByTagName('html')[0].scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        document.getElementsByTagName('body')[0].scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      },
      captchaCancel() {
        this.captchaDialog = false
      },
      captchaEnter() {
        if(this.captcha) {
          this.captchaDialog = false
          this.submit()
        } else {
          this.$toast('请输入图片验证码')
        }
      },
      avatarFailed() {
        this.showAvatar = false
      },
      tackcapture() {
        let video = document.querySelector("#video");
        let canvas = document.querySelector("#canvas"); //
        let img = document.querySelector("#img");
        let context = canvas.getContext('2d');
        // 需要判断媒体流是否就绪
        if(this.streaming){
          context.drawImage(video, 0, 0, video.width, video.height);// 将视频画面捕捉后绘制到canvas里面
          img.src = canvas.toDataURL('image/jpeg');// 将canvas的数据传送到img里
          this.isReady = true
        } else {
          alert('视频流未就绪')
        }
      },
      submit() {
        if(this.isSubmit){
          return
        }
        this.isSubmit = true
        let clazzId = this.$store.state.clazzId,
          type = this.$store.state.faceRecognitionType,
          imgData = document.querySelector("#img").src.replace(/data:image\/jpeg;base64,/, ''),
					logId = sessionStorage.getItem('logId')
				let url = `/m/home/my/facerecog/submit/${clazzId}/${type}?baseimg=true`
				if(type == 3 && logId) {
					url += `&logId=${logId}`
				}
        if(this.hasCaptcha && this.captcha) {
          url += `&_captcha=${this.captcha}`
          this.captcha = ''
        }
        this.$axios.post(
          url,
          encodeURI(imgData),
          { headers: { 'Content-Type': 'text/plain' } }
        )
          .then(resp => {
            this.submitRes(resp.data)
          })
          .catch(err => {
            this.isSubmit = false
            if(err.response.status == '413') {
              this.$toast('图片过大', 1500, 'light-theme')
            }
          })
      },
      submitRes(data) {
        this.isSubmit = false
        if(data) {
          switch (data.status) {
            case 'ok':
            case 'not-required':
              /* 人脸识别成功 */
              this.$toast(data.message ? `${data.message}` : '人脸识别成功')
              sessionStorage.removeItem('startRecog')
              this.$store.commit('faceRecognitionSuccess')
              if(this.$store.state.faceRecognitionType == 1){
                sessionStorage.setItem('successRecogByCourseWare', true)
              }
              if(sessionStorage.getItem('activeSignOut')) {
                /* 签退直接退出 */
                this.$axios.get(`/m/home/my/clazz/courseware/sign/out/${this.$store.state.clazzId}`)
                    .then(res => {
                      let d = res.data
                      switch (d.status) {
                        case 'ok':
                          this.$toast('签退成功')
                          sessionStorage.removeItem('activeSignOut')
                          if(sessionStorage.getItem('repairSignOut')){
                            sessionStorage.removeItem('repairSignOut')
                            this.$router.back()
                          } else {
                            this.$router.go(-2)
                          }
                          break
                        default:
                          this.$toast(d.message || '签退失败', 1500)
                      }
                    })
              } else {
                this.$router.back()
              }
              break
            case 'err':
              // 错误信息改为dialog显示
              // this.$toast(data.message || '人脸检测失败', 1500, 'light-theme')
              this.dialogText = data.message || '人脸检测失败'
              if(sessionStorage.getItem('forceRawHead') && data.compare_fail) {
                this.compare_count = this.compare_count + 1
                if(this.compare_count >= 2) {
                  this.$refs.idPhotoError.showDialog()
                  return
                }
              }
              this.$refs.errorDialog.showDialog()
              break
            case 'req-captcha':
              // 需要验证码
              this.hasCaptcha = true
              this.captchaDialog = true
              break
            case 'err-captcha':
              this.$toast(data.message || '验证码错误！')
              // 需要验证码
              this.hasCaptcha = true
              this.captchaDialog = true
              break
            default:
              this.dialogText = data.message || `未知错误`
              this.$refs.errorDialog.showDialog()
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .fade-in-enter-active,
  .fade-in-leave-active {
    transition: all 0.3s linear;
    opacity: 1;
  }
  .fade-in-enter,
  .fade-in-leave-to {
    opacity: 0;
  }

  .captcha-dialog {
    .dialog-bg {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, .5);
      z-index: 150000;
    }
    .dialog-container {
      width: 270px;
      border-radius: 10px;
      background-color: #fff;
      position: fixed;
      top: 130px;
      left: 50%;
      margin-left: -135px;
      z-index: 150100;
      transition: 300ms;
      .content {
        font-size: 0.14rem;
        padding: 20px;
        padding-bottom: 25px;
        word-break: break-all;
        text-align: center;
        p {
          &.title {
            font-size: 0.16rem;
          }
          &.captcha {
            margin-top: 15px;
            img {
              max-width: 120px;
              height: auto;
              border: 1px solid #e1e1e1;
            }
          }
          &.desc {
            margin-top: 6px;
            font-size: .12rem;
            color: #666;
          }
        }
        .input-cont {
          width: 180px;
          margin: 10px auto 0;
          border-bottom: 1px solid #999;
          input {
            height: 40px;
            line-height: 0.40rem;
            font-size: 0.16rem;
            outline: none;
            width: 100%;
          }
        }
      }
      .active-buttons {
        display: flex;
        border-top: 1px solid #dbdbdb;
        .button {
          padding: 10px 0;
          text-align: center;
          flex-grow: 1;
          border-right: 1px solid #dbdbdb;
          color: $primary;
          /*color: var(--primary);*/
          &.cancel {
            color: #666666!important;
          }
          &:last-child {
            border-right: 0;
          }
        }
      }
    }
  }
  .face-recog {
    .face-recog-container {

      display: flex;
      flex-direction: column;
      width: 640px;
      margin: 30px auto;

      .info-desc {
        background: #000;
        font-size: 12px;
        color: #fff;
        text-align: left;
        padding: 20px 15px;
        .title {
          margin-bottom: 10px;
          strong {
            color: $warning;
            color: var(--warning);
            font-weight: normal;
          }
        }
        .info {
          display: flex;
          justify-content: space-between;
          .avatar {
            flex-shrink: 0;
            width: 64px;
            height: 64px;
            margin-left: 15px;
            position: relative;
            img {
              position: absolute;
              top: 0;
              left: 0;
              bottom: 0;
              right: 0;
              max-width: 100%;
              max-height: 100%;
              margin: auto;
            }
          }
        }
      }
      .video-container {
        width: 640px;
        height: 480px;
        position: relative;
        background: #000;
        .frame-container {
          position: absolute;
          left: 170px;
          top: 90px;
          .frame {
            width: 300px;
            height: 300px;
            position: relative;
            z-index: 999;
            .frame-item {
              width: 20px;
              height: 20px;
              position: absolute;
              &.top {
                top: 0;
                border-top: 2px solid #fff;
              }
              &.bottom {
                bottom: 0;
                border-bottom: 2px solid #fff;
              }
              &.left {
                left: 0;
                border-left: 2px solid #fff;
              }
              &.right {
                right: 0;
                border-right: 2px solid #fff;
              }
            }
          }
        }
      }

      .action-container {
        padding: 20px 30px 25px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .button {
          flex-grow: 1;
          height: 40px;
          margin: 0 8px;
          line-height: 40px;
          border-radius: 20px;
          color: #fff;
          background: #8E8E93;
          display: flex;
          align-items: center;
          justify-content: center;
          &.primary {
            background: $primary;
            background: var(--primary);
          }
          .icon {
            margin-right: 5px;
          }
        }
      }

      .muti-content {
        p {
          margin-bottom: 10px;
          font-size: 13px;
          line-height: 18px;
          &.title {
            font-size: 17px;
            margin-bottom: 20px;
          }
          &.text-left {
            text-align: left;
          }
          strong {
            color: #f00;
          }
          img {
            max-width: 100px;
            max-height: 100px;
          }
        }
        .panel {
          padding: 10px;
          background: #FFF4E3;
          font-size: 12px;
          line-height: 18px;
          .p-title {
            font-size: 13px;
            font-weight: bold;
            margin-bottom: 8px;
          }
          .p-item {
            margin-bottom: 0;
          }
        }
        .active-btn {
          margin-top: 20px;
          padding: 10px;
          border-radius: 6px;
          background: $primary;
					background: var(--primary);
          color: #fff;
          font-size: 17px;
        }
        .active-link {
          font-size: 13px;
          line-height: 18px;
          color: #616161;
          margin-top: 15px;
        }
      }
    }
    .wechat-qr-recog {
      display: flex;
      flex-direction: column;
      width: 640px;
      margin: 30px auto;
      align-items: center;
      .wechat-qr-container {
        width: 300px;
        height: 300px;
        margin-top: 15px;
        position: relative;
        .wechat-qr {
          width: 300px;
          height: 300px;
        }
        .qr-code-modal {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 2;
          background-color: rgba(255, 255, 255, .9);
          display: flex;
          align-items: center;
          justify-content: center;
          .tips {
          }
        }
        .wechat-qr-module {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 2;
          background-color: rgba(255, 255, 255, .9);
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .tip-box {
        margin-top: 15px;
      }
    }
  }
</style>
